import React from 'react';
import { FilterBar, FilterReset, FilterSearch, FilterSelect } from '../../ui/FilterBar/FilterBar';
import type { FilterOption } from '../../ui/FilterBar/FilterBar';
import { STATUS_META, THEMES } from '../../../entities/supportRequests/model/constants';
import type {
    RequestFilters,
    RequestPriority,
    StatusCounts,
    StatusTab,
} from '../../../entities/supportRequests/model/types';

export interface RequestsToolbarProps {
    filters: RequestFilters;
    counts: StatusCounts;
    hasFilters: boolean;
    onQueryChange: (value: string) => void;
    onThemeChange: (value: string) => void;
    onPriorityChange: (value: RequestPriority | '') => void;
    onStatusChange: (value: StatusTab) => void;
    onReset: () => void;
}

const STATUS_TABS: StatusTab[] = ['all', 'new', 'work', 'done', 'rej'];

const STATUS_DOT: Record<StatusTab, string> = {
    all: 'transparent',
    new: 'var(--status-run)',
    work: 'var(--accent-submit)',
    done: 'var(--status-ok)',
    rej: 'var(--color-danger)',
};

const THEME_OPTIONS: FilterOption<string>[] = [
    { value: '', label: 'Все темы' },
    ...THEMES.map((theme) => ({ value: theme, label: theme })),
];

const PRIORITY_OPTIONS: FilterOption<RequestPriority | ''>[] = [
    { value: '', label: 'Любой приоритет' },
    { value: 'high', label: 'Высокий' },
    { value: 'mid', label: 'Средний' },
    { value: 'low', label: 'Низкий' },
];

export function RequestsToolbar({
    filters,
    counts,
    hasFilters,
    onQueryChange,
    onThemeChange,
    onPriorityChange,
    onStatusChange,
    onReset,
}: RequestsToolbarProps) {
    const statusOptions: FilterOption<StatusTab>[] = STATUS_TABS.map((value) => ({
        value,
        label: STATUS_META[value].tab,
        count: counts[value],
        dotColor: STATUS_DOT[value],
    }));

    return (
        <FilterBar>
            <FilterSearch
                value={filters.query}
                placeholder="ID, компания, автор или текст"
                label="Поиск по обращениям"
                onChange={onQueryChange}
            />

            {/* <FilterReset active={hasFilters} onClick={onReset} />

            <FilterSelect
                options={statusOptions}
                value={filters.status}
                allValue="all"
                onChange={onStatusChange}
            />

            <FilterSelect
                options={THEME_OPTIONS}
                value={filters.theme}
                allValue=""
                onChange={onThemeChange}
                wide
            />

            <FilterSelect
                options={PRIORITY_OPTIONS}
                value={filters.priority}
                allValue=""
                onChange={onPriorityChange}
                align="right"
            /> */}
        </FilterBar>
    );
}